import { Center } from "@/components/Center/Center";
import { Button } from "@/components/ui/button";
import LoadingSpinner from "@roman/shared/components/LoadingSpinner";
import { isUnknownAuthState, useAuthStore } from "@roman/shared/store/auth.store";
import { useNavigate } from "react-router-dom";
import { GoogleAuthComponent } from "./Login";

export const Register = () => {
  const navigate = useNavigate();
  const authState = useAuthStore((state) => state.authState);
  const isNewUser = useAuthStore((state) => state.isNewUser);

  if (isUnknownAuthState(authState)) {
    return (
      <Center>
        <LoadingSpinner />
      </Center>
    );
  }

  if (authState === "authenticated") {
    navigate(isNewUser ? "/edit-profile" : "/");
    return null;
  }

  return (
    <div className="w-full max-w-[770px] min-h-[calc(100vh-72px)] bg-white flex justify-center mx-auto">
      <div className="flex items-center justify-center">
        <div className="flex flex-col gap-10 w-full px-4 md:px-0">
          <h1 className="text-2xl font-semibold text-center text-black">新規登録</h1>

          <div className="flex justify-center">
            <GoogleAuthComponent text="Googleで新規登録" />
          </div>

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t backgroundColor-gray" />
            </div>
          </div>

          <div className="space-y-4">
            <h1 className="text-1xl text-center text-black font-['A-OTF Gothic MB101 Pr6N']">
              アカウントをお持ちの方は
            </h1>
            <div className="flex justify-center">
              <Button
                variant="outline"
                onClick={() => navigate("/login")}
                className="flex items-center w-full sm:w-10/12 md:w-9/12 px-4 py-6 rounded-lg border-primary"
              >
                <span className="font-bold w-full text-center text-primary">ログイン</span>
              </Button>
            </div>
          </div>

          <h1 className="text-sm text-center text-gray">
            ログインすることで、
            <a href="/terms-of-service" className="text-secondary underline">
              利用規約
            </a>
            と
            <a href="privacy-policy" className="text-secondary underline">
              プライバシーポリシー
            </a>
            に同意したものとみなされます。
          </h1>
        </div>
      </div>
    </div>
  );
};
